import { Helmet, HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useStoreInfo } from "../hooks/storeInfoHooks/useStoreInfo";

const SEO = ({
  title = "",
  titleTemplate = "",
  description = "",
  keywords = "",
  script = "",
  url,
  image,
}) => {
  const { data: storeInfo } = useStoreInfo();
  const { t } = useTranslation();

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {t(title) || `${storeInfo?.[0]?.name}`} {t(titleTemplate) && "|"}{" "}
          {t(titleTemplate)}
        </title>
        <meta name="description" content={description} />
        {/* keywords */}
        <meta name="keywords" content={keywords} />
        <script type="application/ld+json">{JSON.stringify(script)}</script>
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta
          property="og:image"
          content={image || `${storeInfo?.[0]?.logo}`}
        />
      </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
